import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '@pages/login';
import { AppRoutingKeys } from '@shared';
import { ExportPage } from '@pages/export';
import { DatabaseInitializedGuard, QueryParamsProvider, QueryParamsResolver } from '@domain/routing';
import { WorkfileAccessGuard } from '@domain/authentication';
import { NoApiModeComponent } from '@pages/no-api-mode';

const routes: Routes = [
	{
		path: '',
		redirectTo: AppRoutingKeys.urlPathLogin,
		pathMatch: 'full'
	},
	{
		path: AppRoutingKeys.urlPathLogin,
		component: LoginComponent
	},
	{
		path: AppRoutingKeys.urlPathPlayground,
		loadChildren: () =>
			import('../pages/testing-playground/testing-playground.module').then((m) => m.TestingPlaygroundModule)
	},
	{
		path: `${AppRoutingKeys.urlPathWorkfile}/:${AppRoutingKeys.queryParamsMap.workfileId}`,
		loadChildren: () => import('../pages/workspace/workspace.module').then((m) => m.WorkspacePageModule),
		canActivate: [DatabaseInitializedGuard, WorkfileAccessGuard]
	},
	{
		path: `${AppRoutingKeys.urlPathExport}/:${AppRoutingKeys.queryParamsMap.workfileId}`,
		component: ExportPage,
		canActivate: [DatabaseInitializedGuard]
	},
	{
		path: AppRoutingKeys.urlPathAbout,
		loadChildren: () => import('../pages/about/about.module').then((m) => m.AboutPageModule)
	},
	{
		path: AppRoutingKeys.urlPathHelp,
		loadChildren: () => import('../pages/help/help.module').then((m) => m.HelpModule)
	},
	{
		path: AppRoutingKeys.urlPathSettings,
		loadChildren: () => import('../pages/settings/settings.module').then((m) => m.SettingsPageModule)
	},
	{
		path: AppRoutingKeys.urlPathRegistration,
		loadChildren: () => import('../pages/account/account.module').then((m) => m.AccountPageModule)
	},
	{
		path: AppRoutingKeys.urlPathResetPin,
		loadChildren: () => import('../pages/account/account.module').then((m) => m.AccountPageModule)
	},
	{
		path: AppRoutingKeys.urlPathImport,
		loadChildren: () => import('../pages/import/import.module').then((m) => m.ImportPageModule)
	},
	{
		path: AppRoutingKeys.urlPathNoApiMode,
		component: NoApiModeComponent
	},
	{
		path: '**',
		component: LoginComponent
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
	exports: [RouterModule],
	providers: [WorkfileAccessGuard, DatabaseInitializedGuard, QueryParamsResolver, QueryParamsProvider]
})
export class AppRoutingModule {}
